import { colorConstants } from 'config/colorConstants';

export const ArrowRight = ({ color = colorConstants.white, className = '', strokeWidth = '2' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10" fill="none" className={className}>
  <path d="M1 5H11.6667M11.6667 5L7.66667 1M11.6667 5L7.66667 9" stroke={color} stroke-width={strokeWidth} stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);

export default ArrowRight;
